export const MSEC_PER_DAY = 86_400_000;
export const POLLING_INTERVAL_MS = 30_000;
export const DEFAULT_DATE_RANGE_DAYS = 14;

// 動画検索結果の表示モード。実行中に変化しない固定値なのでstateではなく定数として持つ。
export const MOVIE_SEARCH_RESULT_MODES = {
  NONE: 'none',
  DETAIL: 'detail',
  AREA: 'area',
  ROUTE: 'route',
  ID: 'id',
} as const;
